import { render, staticRenderFns } from "./BiomasaMesAnio.vue?vue&type=template&id=6b389413&scoped=true"
import script from "./BiomasaMesAnio.vue?vue&type=script&lang=js"
export * from "./BiomasaMesAnio.vue?vue&type=script&lang=js"
import style0 from "./BiomasaMesAnio.vue?vue&type=style&index=0&id=6b389413&prod&scoped=true&lang=css"
import style1 from "./BiomasaMesAnio.vue?vue&type=style&index=1&id=6b389413&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b389413",
  null
  
)

export default component.exports